import { Capacitor } from '@capacitor/core'

export const PlatformService = {
	isNative: () => Capacitor.isNativePlatform(),
	isAndroid: () => Capacitor.getPlatform() === 'android',
	isIOS: () => Capacitor.getPlatform() === 'ios',
	isWeb: () => Capacitor.getPlatform() === 'web',
	getPlatform: () => Capacitor.getPlatform()
}

export { CameraService } from './CameraService'
export { GeolocationService } from './GeolocationService'
export { DeviceService } from './DeviceService'
export { FileService } from './FileService'
export { DialogService } from './DialogService'
export { PushService } from './PushService'
export { StatusBarService } from './StatusBarService'
export { IframeBridgeService, isMiseIframe, MESSAGE_TYPES } from './IframeBridgeService'
